var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InformationPage',{attrs:{"name":"Аниме"}},[_c('SecretPage'),_c('a',{staticClass:"text-link",attrs:{"href":"https://shikimori.one/Van0Jan/list/anime"}},[_vm._v("Список просмотренных мною аниме на Шикимори")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }